import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      const session_id = match ? decodeURIComponent(match[1]) : null;
      if (!session_id) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/admin/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post(
          "/auth/session",
          { session_id },
          { headers: { "X-Session-ID": session_id } }
        );
        // Clear hash
        window.history.replaceState(null, "", window.location.pathname);
        setUser(data);
        if (!data.is_admin) {
          toast.error("This Google account isn't on the admin allow-list.");
          navigate("/admin/login", { replace: true, state: { unauthorized: true } });
          return;
        }
        toast.success(`Welcome, ${data.name || data.email}`);
        navigate("/admin", { replace: true, state: { user: data } });
      } catch (e) {
        toast.error("Could not complete sign-in. Please try again.");
        navigate("/admin/login", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="h-10 w-10 border-2 border-[#0369A1] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-sm text-slate-500 font-body">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
